import React, { useMemo } from 'react';
import { Reservation } from '../types';
import { AlertCircle, Calendar, LogIn, LogOut } from 'lucide-react';

interface NotificationsProps {
  reservations: Reservation[];
}

export default function TodayNotifications({ reservations }: NotificationsProps) {
  const today = useMemo(() => new Date().toISOString().split('T')[0], []);
  
  const todayTasks = useMemo(() => {
    const checkIns = reservations.filter(r => r.checkInDate === today && r.status === 'Pendente');
    const checkOuts = reservations.filter(r => r.checkOutDate === today && r.status === 'Iniciado');
    
    return { checkIns, checkOuts };
  }, [reservations, today]);

  if (todayTasks.checkIns.length === 0 && todayTasks.checkOuts.length === 0) {
    return null;
  }

  return (
    <div className="bg-amber-50 border border-amber-200 rounded-xl p-4 mb-6 shadow-sm">
      <div className="flex items-center gap-2 text-amber-900 font-bold text-sm mb-3">
        <AlertCircle className="w-5 h-5" />
        {(todayTasks.checkIns.length + todayTasks.checkOuts.length) === 1 ? '1 Tarefa para hoje' : `${todayTasks.checkIns.length + todayTasks.checkOuts.length} Tarefas para hoje`}
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {todayTasks.checkIns.length > 0 && (
          <div className="bg-white/50 rounded-lg p-3">
            <div className="flex items-center gap-1.5 text-xs text-amber-800 font-bold mb-2">
              <LogIn className="w-3.5 h-3.5" /> Check-ins agendados
            </div>
            <ul className="text-xs text-amber-900 space-y-1">
              {todayTasks.checkIns.map(res => (
                <li key={res.id}>• {res.code} - {res.guestsCount} hóspedes</li>
              ))}
            </ul>
          </div>
        )}
        {todayTasks.checkOuts.length > 0 && (
          <div className="bg-white/50 rounded-lg p-3">
            <div className="flex items-center gap-1.5 text-xs text-amber-800 font-bold mb-2">
              <LogOut className="w-3.5 h-3.5" /> Check-outs agendados
            </div>
            <ul className="text-xs text-amber-900 space-y-1">
              {todayTasks.checkOuts.map(res => (
                <li key={res.id}>• {res.code} - {res.guestsCount} hóspedes</li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
}
